<template>
  <div class="news-detail">
    <div class="defult_width">
      <div class="location">{{language === 'E' ? 'Location：' : '当前位置：'}}<router-link to="/sharingList">{{language === 'E' ? 'Core Values' : '核心价值'}}</router-link> > <span>{{ detail.current.name }}</span></div>
      <div class="left">
        <h5>{{ detail.current.name }}</h5>
        <!-- <div class="time">发布时间：{{ detail.current.time.year + '/' + detail.current.time.month}}</div> -->
        <!-- <img :src="detail.current.img" alt=""> -->
        <div v-for="(item, key) in detail.current.html" :key="key">
          <img v-if="item.img" :src="item.img"  alt="">
          <p v-else v-html="item">
          </p>
        </div>
      </div>
      <div class="right">
        <div class="list-box">
          <h5 class="right-title">{{language === 'E' ? 'Core Values' : '核心价值'}}</h5>
          <ul>
            <li v-for="(item, key) in sharingMore" :key="key">
              <router-link :to="`${item.id}`">
                <img :src="item.img" alt="">
                <h5>
                  {{ item.name }}
                </h5>
                <p>
                  {{ (item.detail).substring(0, 60) + '...' }}
                </p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import index from '@/datas/index'
// import index from '@/datas/index'
import Eindex from '@/EnglishData/index'
export default {
  name: 'coreValuesList',
  data () {
    const language = localStorage.getItem('language')
    let languageIndex = null
    if (language && language === 'E') {
      languageIndex = Eindex
    } else {
      languageIndex = index
    }
    const { coreValuesList } = languageIndex
    return {
      coreValuesList,
      detail: null,
      sharingMore: [],
      productIndex: 0,
      language
    }
  },
  created () {
    let next = null; let pre = null
    let id = parseInt(this.$route.params.id)
    next = (id - 0) === 1 ? this.coreValuesList.length : (id - 0) - 1
    pre = (id - 0) === this.coreValuesList.length ? 1 : (id - 0) + 1
    let list = { current: null, preDetail: null, nextDetail: null }
    this.coreValuesList.forEach((item, index) => {
      if (item.id !== id && this.sharingMore.length < 4) {
        this.sharingMore.push(item)
      }
      if (item.id === id) {
        list.current = item
      }
      if (item.id === next) {
        list.nextDetail = item
      }
      if (item.id === pre) {
        list.preDetail = item
      }
    })
    this.detail = list
    console.log(this.industry)
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.news-detail {
  padding: 0 0 50px;
  border-top: 1px solid #e5e5e5;
  background: #f9f9f9;
  overflow: hidden;
  .location {
    padding: 20px 0;
    text-align: left;
    a {
      color: #333;
    }
  }
  .left {
    width: 65%;
    margin-right: 5%;
    float: left;
    text-align: center;
    h5 {
      font-size: 20px;
      color: 000;
      line-height: 40px;
      font-weight: 800;
      margin-bottom: 30px;
    }
    .time {
      text-align: right;
      color: #888;
      margin: 10px 0 20px;
    }
    p {
      text-align: left;
      line-height: 30px;
      text-indent: 2em;
      margin-bottom: 20px;
    }
    img {
      margin: 0 auto;
      max-width: 100%;
      margin-bottom: 20px;
    }
  }
  .right {
    width: 30%;
    float: right;
    text-align: left;
    .describe {
      background: #fff;
      padding: 20px;
      border-radius: 5px;
      p {
        margin-top: 20px;
        &:last-child {
          text-align: right;
        }
      }
    }
    .right-title {
      font-size: 18px;
      padding-bottom: 15px;
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      &::after {
        position: absolute;
        content: ' ';
        display: block;
        left: 0;
        bottom: -2px;
        width: 45px;
        height: 4px;
        background: #1e50ae;
      }
    }
    .list-box {
      margin-top: 20px;
      background: #fff;
      padding: 20px;
      border-radius: 5px;
      li {
        a {
          display: block;
          padding: 20px 0;
          border-bottom: 1px solid #e5e5e5;
          text-align: center;
          img {
            width: 50%;
          }
          h5 {
            font-size: 16px;
            line-height: 30px;
            color: #1e50ae;
          }
          p {
            font-size: 14px;
            line-height: 24px;
          }
        }
        &:last-child {
          a {
            border: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/TechnologySharing/detail.vue